<template>
  <div v-if="showTableContent" :class="$style.container">
    <div :class="$style.titleSection">
      <div :class="$style.title">Data collection</div>
      <div v-if="dataCollectionSummary.configurationData.length > 5">
        <button
          v-if="showExpandArrow"
          @click="getDataCollection()"
          class="button"
          :class="$style.button"
        >
          <span>View All</span>
          <span class="icon">
            <i class="fas fa-chevron-down"></i>
          </span>
        </button>
        <button
          v-else
          @click="getDataCollection()"
          class="button"
          :class="$style.button"
        >
          <span>View Less</span>
          <span class="icon">
            <i class="fas fa-chevron-up"></i>
          </span>
        </button>
      </div>
    </div>

    <DataCollectionTable
      :data="dataCollectionArray"
      :samplingConfigurations="samplingConfigurations"
    />
  </div>
</template>

<script lang="ts">
import { Component, Vue, Prop, Watch, Model } from 'vue-property-decorator';
import { State, Getter, Action, Mutation, namespace } from 'vuex-class';
import {
  AuditCriteriaMapStatus,
  DataCollectionCriteriaSamplingData,
  DataCollectionSummaryCriteria,
  DataCollectionSummaryRequestPayload,
  DataCollectionSummaryResponsePayload,
} from '../../../store/modules/audits/types/audits.types';
import DataCollectionTable from '../components/DataCollectionTable.vue';
import { get as _get } from 'lodash';

@Component({
  components: {
    DataCollectionTable,
  },
})
export default class DataCollectionList extends Vue {
  @Action('audits/getDataCollectionSummary')
  public getDataCollectionSummary!: (
    payload: DataCollectionSummaryRequestPayload,
  ) => void;

  @State((state) => state.audits.dataCollectionSummary)
  public dataCollectionSummary!: DataCollectionSummaryResponsePayload;

  public dataCollectionArray: any = [];
  public showExpandArrow: boolean = false;
  public showTableContent: boolean = false;

  get _get() {
    return _get;
  }

  get auditId() {
    return this.$route.params.auditId;
  }

  get samplingConfigurations() {
    return this.dataCollectionSummary
      ? this.dataCollectionSummary.samplingConfiguration
      : undefined;
  }

  public getDataCollection(): DataCollectionCriteriaSamplingData | [] {
    if (
      this.dataCollectionSummary &&
      this.dataCollectionSummary.configurationData &&
      Array.isArray(this.dataCollectionSummary.configurationData)
    ) {
      if (this.showExpandArrow) {
        this.showExpandArrow = false;
        this.dataCollectionArray = this.dataCollectionConfigurationData;
      } else {
        this.showExpandArrow = true;
        this.dataCollectionArray = this.dataCollectionConfigurationData.slice(
          0,
          5,
        );
      }
    }
    return [];
  }

  get dataCollectionConfigurationData(): DataCollectionCriteriaSamplingData[] {
    return this.dataCollectionSummary.configurationData
      .filter(
        (dataCollection: DataCollectionSummaryCriteria) =>
          dataCollection.status === AuditCriteriaMapStatus.ACTIVE,
      )
      .map((data: DataCollectionSummaryCriteria) => {
        const samplingConfig = data.criteriaSamplingDataConfigurations?.[0];
        return {
          criteria: data.criteria.title,
          targetSize: samplingConfig
            ? Number(samplingConfig.sampleSize ?? 0)
            : 0,
          minSampleSize: samplingConfig
            ? Number(samplingConfig.minSampleSize ?? 0)
            : 0,
          maxSampleSize: samplingConfig
            ? Number(samplingConfig.maxSampleSize ?? 0)
            : 0,
          isSamplingEnabled: samplingConfig
            ? samplingConfig.isSamplingEnabled
            : false,
          total: data.criteriaSamplingData.total
            ? data.criteriaSamplingData.total
            : 0,
        };
      });
  }

  public async mounted() {
    await this.getDataCollectionSummary({
      auditId: +this.auditId,
    });

    this.getDataCollection();
    this.showTableContent = true;
  }

  public handleNavigate() {
    this.$emit('changeActiveTab', '#dataCollection');
  }
}
</script>

<style lang="scss" module>
.container {
  margin-bottom: 5rem;

  .titleSection {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;

    .title {
      font-weight: bold;
      text-transform: uppercase;
      padding: 8px 0;
    }

    .button {
      border: none;
      background: transparent;
      color: $primary;
    }
  }
}
</style>
